import moment from "moment"


export function createAssignmentsFromData(data) {

    let assignments = []

    data.forEach(assignment => {
        assignments.push({
            ...assignment,
            startTime: moment(`2022-10-10 ${assignment.startTime}`),
            endTime: moment(`2022-10-10 ${assignment.endTime}`).isValid() ? moment(`2022-10-10 ${assignment.endTime}`) : ""
        })
    })


    return assignments
}

export function createSubmitData(formData) {

    let assignments = []

    formData.assignments.forEach(assignment => {
        assignments.push({
            id: assignment.id,
            startTime: assignment.startTime.format("HH:mm:ss"),
            endTime: assignment.endTime.format("HH:mm:ss")
        })
    })

    return { assignments }
}